var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.429 8.143l5.588 3.433l2.143-1.277l-.874-.442l-1.192.768l-4.028-2.482l3.874-2.07l4.826 2.666l.857-.51l-5.606-3.086zm.428 1.08L6 8.68v6.578l5.571 3.6v-6.801L9.43 10.715v1.032l1.285.832v4.62l-3.857-2.473zm5.572 8.546v1.084L18 15.28V8.7l-5.571 3.356v2.606l.857-.553V12.6l3.857-2.314v4.466l-4.714 3.021z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGala);
export default __webpack_public_path__ + "static/media/gala.d6a18c9fe9602aad561c1f8ff63870a7.svg";
export { ForwardRef as ReactComponent };